import { render, staticRenderFns } from "./manage-remind.vue?vue&type=template&id=4b42f353&scoped=true&"
import script from "./manage-remind.vue?vue&type=script&lang=js&"
export * from "./manage-remind.vue?vue&type=script&lang=js&"
import style0 from "./manage-remind.vue?vue&type=style&index=0&id=4b42f353&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b42f353",
  null
  
)

export default component.exports